import React from 'react';
import { normalizeMembershipFormConfig } from '../utils/membership';

function MemberReviewModal({ confirmMembership, currentUser, getClubById, reviewMember, setReviewMember, users }) {
  const reviewClub = getClubById(reviewMember.ClubId);
  const reviewConfig = normalizeMembershipFormConfig(reviewClub && reviewClub.membershipFormConfig);
  const reviewExtra = reviewMember.membershipExtraData && typeof reviewMember.membershipExtraData === 'object' && !Array.isArray(reviewMember.membershipExtraData)
    ? reviewMember.membershipExtraData
    : {};
  const reviewFields = (reviewConfig.fields || [])
    .filter(field => field && field.enabled && field.storage === 'platform')
    .filter(field => field.key !== 'fullName' && field.key !== 'email' && field.key !== 'yearsPlaying');
  const reviewValue = (field) => {
    if (field.key === 'phone') return reviewMember.phone;
    if (field.key === 'membershipType') return reviewMember.membershipType;
    if (field.key === 'playerType') return reviewMember.playerType;
    return reviewExtra[field.key];
  };
  const displayReviewValue = (field) => {
    const value = reviewValue(field);
    if (value === undefined || value === null || value === '') return '—';
    if (field.type === 'boolean') return value ? 'Yes' : 'No';
    return String(value);
  };
  return (
    <div className="w3-modal" style={{ display: 'block', zIndex: 2000 }}>
      <div className="w3-modal-content w3-card-4 w3-round w3-animate-top" style={{ maxWidth: '680px' }}>
        <div className="w3-container w3-theme-d4 w3-round-top" style={{ padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <strong><i className="fa fa-file-text-o w3-margin-right"></i>Membership Form Review</strong>
          <button className="w3-button w3-round" onClick={() => setReviewMember(null)}>&times;</button>
        </div>
        <div className="w3-container w3-padding">
          <div className="w3-panel w3-pale-yellow w3-leftbar w3-border-amber w3-round">
            <strong>{reviewMember.membershipPendingIntent === 'renew' ? 'Renewal' : 'Membership'} pending approval</strong>
            <div className="w3-small w3-text-grey">Read-only copy of the values stored in the platform.</div>
          </div>
          <div className="w3-row-padding">
            {[
              ['Full Name', reviewMember.name],
              ['Email', reviewMember.email],
              ['Bowling Start Year', reviewMember.bowlingStartYear],
              ['Membership Type', reviewMember.membershipType],
              ['Player Type', reviewMember.playerType],
              ...(reviewMember.membershipPendingIntent === 'renew' ? [['Renewal Year', reviewMember.membershipPendingRenewalYear]] : []),
              ...reviewFields.map(field => [field.label, displayReviewValue(field)]),
            ].map(([label, value]) => (
              <div key={label} className="w3-col m6 s12 w3-margin-bottom">
                <div className="w3-small w3-text-grey">{label}</div>
                <div className="w3-border-bottom" style={{ minHeight: '26px', padding: '3px 0', fontWeight: 600 }}>{value || '—'}</div>
              </div>
            ))}
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '8px' }}>
            <button className="w3-button w3-light-grey w3-round" onClick={() => setReviewMember(null)}>Close</button>
            {currentUser.role === 'club-admin' && (
              <button className="w3-button w3-green w3-round" onClick={() => { setReviewMember(null); confirmMembership(reviewMember); }}>
                <i className="fa fa-check w3-margin-right"></i>Approve
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MemberReviewModal;
